import { useDispatch, useSelector } from 'react-redux';
import { selectAlert, clearAlert } from '../../../services/alert/slices';
import { showErrorAlert, showInfoAlert, showSuccessAlert } from '../../../services/alert/thunks';

export default function useAlert() {
  const _dispatch = useDispatch();
  const alert = useSelector(selectAlert);

  const dispatch = (actionCreator) => {
    const result = _dispatch(actionCreator);    
    return result;
  };

  return {
    alert,
    showError: (message, title) => dispatch(showErrorAlert(message, title)),
    showInfo: (message, title) => dispatch(showInfoAlert(message, title)),
    showSuccess: (message, title) => dispatch(showSuccessAlert(message, title)),
    clear: () => dispatch(clearAlert())
  };
}
